
import { computed, defineComponent } from 'vue';

export default defineComponent({
  name: 'SelecionarTipoFiltroRelatorioPCP',
  props: {
    codigosSelecionados: {
      type: Array as () => number[],
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:codigosSelecionados'],
  setup(props, { emit }) {
    const opcoes = [
      { value: 1, label: 'Tipo de Produção' },
      { value: 2, label: 'Engenharia de Produto' },
      { value: 3, label: 'Matéria-Prima' },
    ];

    const computedValor = computed({
      get: () => props.codigosSelecionados,
      set: (value) => {
        emit('update:codigosSelecionados', value);
      },
    });

    return {
      opcoes,
      computedValor,
    };
  },
});
